export enum EditableDataTableColumnFilter {
  CNPJ,
  DATA,
  AUTOCOMPLETE,
  NONE,
}
